import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Row.module.scss';
import clsx from 'clsx';
const Row = ({ label, value }) => {
  return (
    <>
      <div className={clsx(styles.item)}>
        <div className={clsx(styles.label)}>{label}</div>
        <div className={clsx(styles.value)}>{value}</div>
      </div>
    </>
  );
};

export default Row;
